import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  useDisclosure,
  useToast,
} from '@chakra-ui/react'
import Axios from 'axios'
import { useState } from 'react'
import { useQueryClient } from 'react-query'
import { apiBlog } from '../../../../services/api'



export function ModalDeletePost({ userBlog, id }) {
  const {
    isOpen,
    onOpen,
    onClose,
  } = useDisclosure()

  const toast = useToast()

  const [loading, setLoading] = useState(false)

  const queryClient = useQueryClient()
  
  async function deletePost() {
    setLoading(true)
    try {
      const response = await apiBlog.delete(`/post/${id}`, {
        headers: {
          Authorization: `Bearer ${userBlog.token}`
        }
      })
      console.log(response)

      setLoading(false)
      queryClient.invalidateQueries('posts')
      onClose()

      toast({
        title: 'Post deletado com sucesso',
        status: 'success',
        duration: 3000,
        isClosable: true,
      })



    } catch (error) {
      console.log(error)
      setLoading(false)

      toast({
        title: 'Erro ao deletar o post',
        status: 'error',
        duration: 3000,
        isClosable: true,
      })
      
    }

  }

  return (
    <>
    <Button onClick={onOpen} colorScheme='red'>Deletar</Button>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Deletar post</ModalHeader>
          <ModalCloseButton />
            <ModalBody>
              Tem certeza que deseja deletar este post?
            </ModalBody>
          <ModalFooter>
            <Button colorScheme='blue' mr={3} onClick={onClose}>
              Fechar
            </Button>
            <Button 
              variant='ghost'
              onClick={deletePost}
              isLoading={loading}
            >
              Confirmar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}